<template>
<div>
    <div class="layerWrapper" v-show="showStatusLayer">
    </div>
    <div class="popupContent" v-show="showStatusLayer">
        <div class="inner">
            <a class="closeLayerButton" @click="closeStatusLayer"></a>
            <div class="title"><!--경쟁 현황-->{{$t("competitionBoard.code001")}}</div>
            <div class="content">
                <div class="input-content">
                    <div class='heading'>
                        <a v-bind:class="{ active:isCompetition }" v-on:click="getGroupTopic(3)"><!--경쟁 중인 그룹-->{{$t("competitionBoard.code002")}}</a>
                        <span class="active">|</span>
                        <a v-bind:class="{ active:isWaiting }" v-on:click="getGroupTopic(2)"><!--경쟁 대기 그룹-->{{$t("competitionBoard.code003")}}</a>
                        <span class="active">|</span>
                        <a v-bind:class="{ active:isComplete }" v-on:click="getGroupTopic(4)"><!--경쟁 완료 그룹-->{{$t("competitionBoard.code004")}}</a>
                    </div>
                    <div v-show="groupList.length > 0">
                        <a v-show="selectedIdx != 0" class="slider left" @click="groupShift(-1)"></a>
                        <a v-show="selectedIdx + 1 < groupList.length" class="slider right" @click="groupShift(1)"></a>
                        <div>
                            <table class="group-info">
                                <tr class=''>
                                    <td class="label"><!--경쟁기간-->{{$t("competitionBoard.code005")}}</td>
                                    <td>
                                        
                                        {{ utc2(selectedGroup.competitionBeginDate + " " + selectedGroup.competitionBeginHour, "yyyy-MM-dd HH:mm") + ' ~ ' + utc2(selectedGroup.competitionEndDate + " " + selectedGroup.competitionEndHour, "yyyy-MM-dd HH:mm") }}

                                    </td>
                                    <td class="label">
                                        <span style="color:#ff0000;" v-show="selectedGroup.mcfTopic && selectedGroup.countOfSubmission < selectedGroup.mcfTopic.maxCount">
                                            <!--(수정)-->{{$t("competitionBoard.code006")}} </span><span><!--그룹 금액-->{{$t("competitionBoard.code007")}}</span>
                                    </td>
                                    <td><!--￦-->{{$t("competitionBoard.code008")}}{{selectedGroup.mcfTopic? selectedGroup.mcfTopic.amountPerUser * selectedGroup.countOfSubmission : '' |numberFormat}}</td>
                                </tr>
                                <tr class=''>
                                    <td class="label"><!--경쟁상태-->{{$t("competitionBoard.code009")}}</td>
                                    <td class="state">{{submissionStatusText}}
                                    </td>
                                    <td class="label"><span style="color:#ff0000;" v-show="selectedGroup.mcfTopic && selectedGroup.countOfSubmission < selectedGroup.mcfTopic.maxCount">
                                        <!--(수정)-->{{$t("competitionBoard.code006")}} </span><span><!--그룹 인원-->{{$t("competitionBoard.code010")}}</span>
                                    </td>
                                    <td>{{selectedGroup.countOfSubmission|numberFormat}}</td>
                                </tr>
                                <tr class=''>
                                    <td class="label"><!--주제-->{{$t("competitionBoard.code011")}}</td>
                                    <td>{{selectedGroup.mcfTopic? selectedGroup.mcfTopic.topic : ''}}
                                    </td>
                                    <td class="label"><!--총 제작-->{{$t("competitionBoard.code012")}}</td>
                                    <td>{{selectedGroup.countOfOrder === 0? '--' : selectedGroup.countOfOrder}}
                                    </td>
                                </tr>
                            </table>
                            <div class="updated-date">
                                <!--집계시각-->{{$t("competitionBoard.code013")}} 
                                {{ utc(selectedGroup.competitionUpdateAt, "yyyy-MM-dd HH:mm:ss") }} 
                            </div>
                            <table class="default-table submission-list">
                                <tr>
                                    <th style="width:108px;"><!--전체 순위-->{{$t("competitionBoard.code014")}}</th>
                                    <th style="width:324px;"><!--제출 작품명-->{{$t("competitionBoard.code015")}}</th>
                                    <th style="width:108px;"><!--제작건수-->{{$t("competitionBoard.code016")}}</th>
                                    <th style="width:108px;"><!--제작비율-->{{$t("competitionBoard.code017")}}</th>
                                    <th style="width:216px;"><!--확보금액-->{{$t("competitionBoard.code018")}}</th>
                                </tr>
                                <tr v-for="submission in selectedGroup.mcfGroupSubmissions" :key="submission.uuid">
                                    <td>{{isWaiting ? '--' : submission.ranking}}</td>
                                    <td>
                                    <template v-if="templateType(submission) === 'video'">
                                        <a v-on:click="playVideo(submission.mcfSubmission.letterTemplates.videoUrl)">
                                            {{submission.mcfSubmission.letterTemplates.name}}</a>
                                    </template>
                                    <template v-else-if="templateType(submission) === 'bcon'">
                                        <a v-on:click="showImage(submission.mcfSubmission.letterTemplates.thumbnailUrl)">
                                            {{submission.mcfSubmission.letterTemplates.name}}</a>
                                    </template>
                                    <template v-else>
                                        <!-- - 템플릿 정보가 없습니다.-->{{$t("competitionBoard.code019")}} 
                                    </template>
                                    </td>
                                    <td>{{isWaiting ? '--' : submission.countOfOrder}}</td>  
                                    <td>{{submission.ratio}}%</td>
                                    <td><!--￦-->{{$t("competitionBoard.code008")}}{{submission.accumulationAmount|numberFormat}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div v-show="groupList.length === 0 && !isLoading" class="no-result">
                        <img :src="localeImg001" width="468" height="340">
                    </div>
                    <div v-show="isLoading" class='loding-list'>
                        <img class="loading-indicator" src="../../assets/images/common/ajax-loader.gif">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mediaCover" v-show="showMediaLayer" @click="hideMediaLayer"></div>
    <div class="mediaLayer" v-show="showMediaLayer">
        <div class="inner">
            <a class="closeButton" @click="hideMediaLayer"></a>
            <video-player class="video-player-box"
                            ref="videoPlayer"
                            :options="playerOptions">
            </video-player>
        </div>
    </div>
    <div class="imageCover" v-show="showImageLayer" @click="hideImageLayer"></div>
    <div class="imageLayer" v-show="showImageLayer">
        <div class="inner">
            <a class="closeButton" @click="hideImageLayer"></a>
            <img :src="this.imageLayerImageUrl">
        </div>
    </div>
</div>    
</template>

<script>
    import 'video.js/dist/video-js.css'
    import {videoPlayer} from 'vue-video-player'

    export default {
        props: {
            
        },
        mounted: function() {

        },
        created: function() {
            
        },
        computed: {
          isCompetition() {
            return this.submissionStatus === 3 ? true : false
          },
          isWaiting () {
            return this.submissionStatus === 2 ? true : false
          },
          isComplete () {
            return this.submissionStatus === 4 ? true : false
          },
          submissionStatusText() {
            if(this.submissionStatus === 2){
              //경쟁 대기
              return this.$i18n.t('competitionBoard.code020')
            } else if(this.submissionStatus === 3){
              //경쟁 중
              return this.$i18n.t('competitionBoard.code021')
            } else if(this.submissionStatus === 4){
              //경쟁 완료
              return this.$i18n.t('competitionBoard.code022')
            }
          },
            localeLang() { return this.$i18n.t('lang') }, 
            localeImg001() {
                var imgSrc = require('@/assets/locale/ko/images/blnk_img.png')
                var imgSrcEn = require('@/assets/locale/en/images/blnk_img.png')
                if (this.localeLang == "en") { imgSrc = imgSrcEn }
                return imgSrc
            },
        },
        components: {
            videoPlayer
        },        
        data: function () {
            return {
                showStatusLayer: false,
                topicUuid: '',
                groupList: [],
                selectedGroup: {},
                selectedIdx: 0,
                submissionStatus: 3,
                isLoading: false,
                showMediaLayer: false,
                playerOptions: {
                    // videojs options
                    muted: false,
                    language: 'ko',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    autoplay: true,
                    poster: "",
                    sources: [],
                },       
                showImageLayer: false,   
                imageLayerImageUrl: '',      
            }
        },
        methods: {
            async openStatusLayer(uuid) {
              this.resetPopupData()
              this.topicUuid = uuid
              this.getGroupTopic(3)
              this.showStatusLayer = true;
            },
            resetPopupData() {
              this.topicUuid = ''
              this.groupList =  []
              this.selectedGroup = {}
              this.selectedIdx = 0
              this.submissionStatus = 3
            },            
            async getGroupTopic(submissionStatus) { 
              this.groupList =  []
              this.selectedGroup = {}
              this.selectedIdx = 0
              this.submissionStatus = submissionStatus
              this.isLoading = true
              let response = await this.$api.getGroupTopic(1, 100, submissionStatus, this.topicUuid)
              this.isLoading = false
              if (response.status == 200) {
                  if(response.data.lists && response.data.lists.length > 0)
                  {
                    this.groupList = response.data.lists
                    this.selectedGroup = response.data.lists[0]
                  } 
              } else {
              }
            },
            groupShift(idx) {
              this.selectedIdx += idx
              this.selectedGroup = this.groupList[this.selectedIdx]
            },
            closeStatusLayer() {
              this.showStatusLayer = false;
            },
            templateType: function(submission) {
                var html = ""
                try {
                    if (submission.mcfSubmission.letterTemplates.tType === 'video') {
                        html = "video"
                    } else if (submission.mcfSubmission.letterTemplates.tType === 'bcon') {
                        html = "bcon"
                    }    
                } catch (error) {
                    console.log(error)
                }
                
                return html
            },            
            playVideo(url) {
                this.showMediaLayer = true
                this.playerOptions.sources = [{
                    type: "video/mp4",
                    src: url
                }]
            },
            showImage(url) {
                this.showImageLayer = true
                this.imageLayerImageUrl = url
            },      
            hideMediaLayer() {
                this.playerOptions.sources = [{
                    type: '',
                    src: ''
                }]
                this.showMediaLayer = false
            },    
            hideImageLayer() {
                this.showImageLayer = false
            },  
            utc2(dateText, dateType) {
                return this.$utc(dateText, dateType)
            },
            utc(dateText, dateType) {
                return this.$utc(dateText, dateType)
            },
        }
    }
</script>
<style>
    div.mediaLayer .video-js .vjs-big-play-button { 
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -45px;
        margin-top: -23.5px; 
    }

    div.video-js {
        margin: 0 auto; 
    }
</style>
<style scoped lang="scss"> 
    div.layerWrapper {
        width: 100%;
        height: 100%;
        background: #000000;
        top: 0;
        left: 0;
        position: fixed;
        z-index: 200;
        opacity: 0.5;
    }

    div.popupContent {
        top: 50%;
        left: 50%;
        position: fixed;
        width: 1000px;
        height: 800px;
        background: #ffffff;
        z-index: 1000;
        margin-left: -500px;
        margin-top: -400px;
        overflow-y: auto;

        div.inner {
            position: relative;
            padding: 40px;

            div.title {
                color: #666666;
                font-size: 18px;
                padding-bottom: 10px;
                border-bottom: 1px solid #cccccc;
            }

            a.closeLayerButton {
                position: absolute;
                display: inline-block;
                width: 32px;
                height: 32px;
                top: 20px;
                right: 40px;
                background: url('../../assets/images/common/close-layer-button.png') top center no-repeat;
            }

            div.content {
                padding: 28px; 

                div.input-title {
                    display: inline-block;
                    color: #666666;
                    font-size: 16px;
                    vertical-align: middle;
                    margin-right: 20px;
                    width: 150px;
                }
                div.input-content {
                    display: inline-block;
                    vertical-align: middle;
                    width: 100%;
                    div.heading {
                      margin-bottom: 46px;
                      a {
                        font-size: 16px;
                        color: #999999;
                      }
                      a.active, span {
                        color: #0099ff;
                      }
                      span {
                        margin: 0 18px;
                      }
                    }
                    a.slider {
                      position: absolute;
                      display: inline-block;
                      width: 15px;
                      height: 30px;
                      top: 525px;
                    }
                    a.slider.left {
                      left: 30px;
                      background: url('../../assets/images/common/left-slider.png') top center no-repeat;
                      background-size: 15px 30px;
                    }
                    a.slider.right {
                      right: 30px;
                      background: url('../../assets/images/common/right-slider.png') top center no-repeat;
                      background-size: 15px 30px;
                    }
                    table.group-info {
                      width: 100%;
                      margin-bottom: 20px;
                      font-size: 14px;
                      color: #999999;
                      tr {
                        height: 39px;
                        line-height: 39px;
                        border-bottom: 1px dotted #999999;
                        td.label {
                          font-size: 16px;
                          color: #666666;
                        }
                        td.state {
                          color: #0099ff;
                        }
                      }
                      tr:last-child {
                        border-bottom: 1px solid #666666;
                      }
                    }
                    div.updated-date {
                      margin-bottom: 9px;
                      text-align: right;
                      font-size: 14px;
                      color: #999999;
                    }
                    table.submission-list {
                      max-height: 440px;
                      overflow-y: scroll;

                      th, td {
                          text-align: center;
                      }
                    }
                    div.no-result {
                      img {
                        position: absolute;
                        top:200px;
                        left:269px;
                      }
                    }
                    div.loding-list{
                      img.loading-indicator {
                        position: absolute;
                        top:450px;
                        left:484px;
                      }
                    }
                }
            }
        }
    }

    div.mediaLayer .video-js .vjs-big-play-button {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -45px;
        margin-top: -23.5px;
    }

    div.mediaCover {
        background: #000000;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1200;
        opacity: 0.8;
    }

    div.mediaLayer {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 720px;
        height: 404px;
        margin-left: -360px;
        margin-top: -402px;
        z-index: 1201;

        div.inner {
            position: relative;
            width: 100%;
            height: 100%;

            a.closeButton {
                position: absolute;
                top: -50px;
                right: 0px;
                display: inline-block;
                width: 32px;
                height: 32px;
                background: url('../../assets/images/common/icon-close.png') top center no-repeat
            }
        }
    }

    div.imageCover {
        background: #000000;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1200;
        opacity: 0.8;
    }

    div.imageLayer {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 720px;
        height: 404px;
        margin-left: -360px;
        margin-top: -202px;
        z-index: 1201;

        div.inner {
            position: relative;
            width: 100%;
            height: 100%;

            a.closeButton {
                position: absolute;
                top: -50px;
                right: 0px;
                display: inline-block;
                width: 32px;
                height: 32px;
                background: url('../../assets/images/common/icon-close.png') top center no-repeat
            }

            img {
                width: 100%;
                height: auto;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/job/CompetitionBoard.vue